import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchBusinessUnitListModule } from "./helpAndAssistantApi";

export interface BusinessUnitListState {
  businessUnitList: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: BusinessUnitListState = {
    businessUnitList: [],
    status: "idle",
};

export const GetBusinessUnitList = createAsyncThunk(
  "BusinessUnitList/fetchCompany",
  async (data:any) => {
    const response = await fetchBusinessUnitListModule(data);
    return response;
  }
);

export const BusinessUnitListSlice = createSlice({
  name: "BusinessUnitList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetBusinessUnitList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetBusinessUnitList.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetBusinessUnitList.fulfilled, (state, action) => {
        state.status = "idle";
        state.businessUnitList = action.payload.BU;
      });
  },
});

export const {} = BusinessUnitListSlice.actions;

export const selectBusinessUnitList = (state: RootState) => {
  return state.BusinessUnitList.businessUnitList;
};

export default BusinessUnitListSlice.reducer;
